import { createContext } from 'react';

// Types
import { LayoutSize } from '../../types/LayoutTypes';

type LayoutContext = {
  layout: LayoutSize,
  updateLayout: Function
};

export default createContext<LayoutContext>({
  layout: 'desktop',
  updateLayout: () => {
    console.log('updateLayout function called');
  }
});